import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EventAcademy } from 'src/app/models/event/event.model';
import { MaintenanceReminder, MaintenanceReminderUser } from 'src/app/models/maintenance/maintenance.model';
import { News } from 'src/app/models/news/news.model';
import { AuthService } from '../../authentication/auth.service';
import { BaseApiService } from '../../base-api.service';
import { TranslateFirebaseService } from '../../utils/translate-firebase.service';

@Injectable()
export class RestAgendaService extends BaseApiService {

  constructor(httpClient: HttpClient,
    translate : TranslateFirebaseService,
    private authService : AuthService) {
    super(httpClient, translate);
  }

  createAgendaElement(element: FormData | News | EventAcademy): Observable<News | EventAcademy | MaintenanceReminderUser> {
    return this.httpClient.post<News | EventAcademy>(super.getUpsApiHost() + "Agenda", element, { headers: this.authService.upsHttpHeaders });
  }

  createMaintenanceReminderUser(element: MaintenanceReminderUser): Observable<MaintenanceReminderUser> {
    return this.httpClient.post<MaintenanceReminderUser>(super.getUpsApiHost() + "Agenda/reminder", element, { headers: this.authService.upsHttpHeaders });
  }

  updateAgendaElement(element: FormData | News | EventAcademy): Observable<News | EventAcademy> {
    return this.httpClient.put<News | EventAcademy>(super.getUpsApiHost() + "Agenda", element, { headers: this.authService.upsHttpHeaders });
  }

  updateMaintenanceReminderUser(element: MaintenanceReminderUser): Observable<MaintenanceReminderUser> {
    return this.httpClient.put<MaintenanceReminderUser>(super.getUpsApiHost() + "Agenda/reminder", element, { headers: this.authService.upsHttpHeaders });
  }

  deleteAgendaElement(id: number): Observable<any> {
    return this.httpClient.delete<any>(super.getUpsApiHost() + "Agenda/" + id, { headers: this.authService.upsHttpHeaders });
  }

  deleteMaintenanceReminderUser(id: number): Observable<any> {
    return this.httpClient.delete<any>(super.getUpsApiHost() + "Agenda/reminder/" + id, { headers: this.authService.upsHttpHeaders });
  }

  hideAgendaElement(id: number): Observable<any> {
    return this.httpClient.get<any>(super.getUpsApiHost() + "Agenda/hide/" + id, { headers: this.authService.upsHttpHeaders });
  }

  //***********GET APIs

  getAgendaElementsByType(cardType: number): Observable<News[] | EventAcademy[] | MaintenanceReminderUser[]> {
    return this.httpClient.get<News[] | EventAcademy[] | MaintenanceReminderUser[]>(super.getUpsApiHost() + "Agenda/all/" + cardType, { headers: this.authService.upsHttpHeaders });
  }

  getAgendaElementsByUser(languageId: string): Observable<News[] | EventAcademy[] | MaintenanceReminderUser[]> {
    return this.httpClient.get<News[] | EventAcademy[] | MaintenanceReminderUser[]>(super.getUpsApiHost() + 'Agenda/user/' + languageId, { headers: this.authService.upsHttpHeaders });
  }

  getNotificationCount(languageId: string) : Observable<any> {
    return this.httpClient.get<any>(super.getUpsApiHost() + "Agenda/usernotificationcount/" + languageId, { headers: this.authService.upsHttpHeaders });
  }

  getAgendaElementById(id: number) : Observable<News | EventAcademy> {
    return this.httpClient.get<News | EventAcademy>(super.getUpsApiHost() + "Agenda/" + id, { headers: this.authService.upsHttpHeaders });
  }

  getUserReminderById(id: number) : Observable<MaintenanceReminderUser> {
    return this.httpClient.get<MaintenanceReminderUser>(super.getUpsApiHost() + "Agenda/reminder/" + id, { headers: this.authService.upsHttpHeaders });
  }

  getMaintenanceReminderById(id: number) : Observable<MaintenanceReminder> {
    return this.httpClient.get<MaintenanceReminder>(super.getUpsApiHost() + "Maintenance/" + id, { headers: this.authService.upsHttpHeaders });
  }

  getUserCountNotification(languageId : string): Observable<number> {
    return this.httpClient.get<number>(super.getUpsApiHost() + 'Agenda​/usernotificationcount​/' + languageId, { headers: this.authService.upsHttpHeaders });
  }
}
